import CompanyIntroductionComponent from '../components/company-introduction/company-introduction';

const CompanyIntroduction = () => <CompanyIntroductionComponent />;

export default CompanyIntroduction;
